import angular from 'angular';
import selectMergeContactTypeModal from './selectMergeContactTypeModal';

export default angular
  .module('mergeContact.scene.selectMergeContactType.components', [])
  .component('selectMergeContactTypeModal', selectMergeContactTypeModal).name;
